import React from 'react';

const ExpenseDetail: React.FC = () => {
  return (
    <div>
      {/* Expense detail view will go here */}
    </div>
  );
};

export default ExpenseDetail; 